import { render, staticRenderFns } from "./SearchKeyword.vue?vue&type=template&id=54e832d7&"
import script from "./SearchKeyword.vue?vue&type=script&lang=ts&"
export * from "./SearchKeyword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports